"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = Header;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    padding-left: ", "px\n    padding-right: ", "px\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    min-height: ", "px;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    height: 100%;\n    min-width: fit-content;\n    max-width: ", ";\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: ", "px;    \n    padding-right: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: inherit;\n    display: flex;\n    align-items: center    \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    font-family: ", ";\n    top: ", ";\n    position: ", ";\n    z-index: ", ";\n    width: 100%;    \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeaderParentWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.fixed ? 0 : 'auto';
}, function (props) {
  return props.fixed ? 'fixed' : 'relative';
}, function (props) {
  return props.spacingObj.zIndex;
});

var HeaderWrapper = _styledComponents["default"].div(_templateObject2());

var InnerHeaderWrapper = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.fitToGrid ? props.spacingObj.gridWidth + "px" : "none";
}, function (props) {
  return props.spacingObj.padding * 2;
}, function (props) {
  return props.spacingObj.padding * 2;
});

var TitleWrapper = _styledComponents["default"].span(_templateObject4(), function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.leftIcon ? props.spacingObj.padding * 4 : 0;
}, function (props) {
  return props.leftIcon ? props.spacingObj.padding * 4 : 0;
});
/**
 * Headers are used to display content at the top of a page.
 * @example import { Header } from '@desktop/react';
 */


function Header(props) {
  var inherit = "navbar";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit];
  var colors = context.getColors()[inherit];

  var topHeader = /*#__PURE__*/_react["default"].createElement(HeaderWrapper, _defineProperty({
    key: "primary header",
    spacingObj: spacing
  }, "key", "primary-header"), /*#__PURE__*/_react["default"].createElement(InnerHeaderWrapper, {
    fitToGrid: props.fitToGrid,
    spacingObj: spacing
  }, props.leftIcon, props.title && /*#__PURE__*/_react["default"].createElement(TitleWrapper, {
    key: "title",
    leftIcon: props.leftIcon,
    elements: props.children,
    spacingObj: spacing,
    style: props.titleStyle
  }, props.title), props.children));

  var secondaryHeaders = [];
  props.secondaryHeaders.map(function (header, i) {
    secondaryHeaders.push( /*#__PURE__*/_react["default"].createElement(HeaderWrapper, {
      key: "header " + i,
      style: header.style,
      spacingObj: spacing
    }, /*#__PURE__*/_react["default"].createElement(InnerHeaderWrapper, {
      fitToGrid: props.fitToGrid,
      spacingObj: spacing
    }, header.elements)));
  });
  return /*#__PURE__*/_react["default"].createElement(HeaderParentWrapper, {
    style: props.style,
    spacingObj: spacing,
    colorObj: colors,
    fixed: props.fixed,
    fontFamilyObj: context.getFont()
  }, topHeader, secondaryHeaders);
}

Header.propTypes = {
  /**The content of the main header. */
  children: _propTypes["default"].node,

  /**Extends the base styling of the main header. */
  style: _propTypes["default"].object,

  /**The title of the main header. */
  title: _propTypes["default"].node,

  /**Content displayed on the left of the main header. */
  leftIcon: _propTypes["default"].node,

  /**Extends the base styling of the main header title. */
  titleStyle: _propTypes["default"].object,

  /**Gives the header elements padding to fit them to a grid. */
  fitToGrid: _propTypes["default"].bool,

  /**An array of objects that make up the secondary headers. */
  secondaryHeaders: _propTypes["default"].array,

  /**Boolean that makes the header fixed on the page. */
  fixed: _propTypes["default"].bool
};
Header.defaultProps = {
  style: {},
  titleStyle: {},
  fitToGrid: false,
  fixed: false,
  secondaryHeaders: [],
  title: null,
  leftIcon: null
};